import t from "@ext/localization/locale/translate";
import { IconButton } from "@ui-kit/Button";
import { PanelListItem } from "@ui-kit/FloatingPanel";
import type { ToolsTreeNode } from "../../model/types";
import { tui } from "../locale";
import { ToolExpander } from "../tree/ToolExpander";

type WorkspaceToolsTreeRowProps = {
	item: ToolsTreeNode;
	depth: number;
	expanded: boolean | null;
	gutter: boolean;
	onToggle: () => void;
	onOpen: () => void;
};

export const WorkspaceToolsTreeRow = ({
	item,
	depth,
	expanded,
	gutter,
	onToggle,
	onOpen,
}: WorkspaceToolsTreeRowProps) => (
	<PanelListItem
		data-testid={`workspace-tools-row-${item.id}`}
		depth={depth}
		description={item.children.length ? undefined : item.description || tui("no-content")}
		leading={
			expanded === null ? (
				gutter && <ToolExpander expanded={null} />
			) : (
				<FolderToggle expanded={expanded} onToggle={onToggle} />
			)
		}
		onOpen={onOpen}
		openTestId={`workspace-tools-node-${item.id}`}
		title={item.title || tui("untitled")}
	/>
);

const FolderToggle = ({ expanded, onToggle }: { expanded: boolean; onToggle: () => void }) => (
	<IconButton
		aria-expanded={expanded}
		aria-label={t(expanded ? "collapse" : "expand")}
		className="size-4 p-0 transition-colors"
		icon={expanded ? "chevron-down" : "chevron-right"}
		iconClassName="size-4"
		onClick={onToggle}
		type="button"
		variant="text"
	/>
);
